export async function generateSHA256Hash(input: string): Promise<string> {
  // Encode the input data as a Uint8Array
  const encoder = new TextEncoder()
  const data = encoder.encode(input)

  // Hash the data
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)

  // Convert the hash to a hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export function arrayBufferToHex(buffer: ArrayBufferLike): string {
  return uint8ArrayToHex(new Uint8Array(buffer))
}

export function uint8ArrayToHex(byteArray: Uint8Array): string {
  return Array.from(byteArray)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}

export function int8ArrayToHex(byteArray: Int8Array): string {
  return uint8ArrayToHex(new Uint8Array(byteArray.buffer))
}

export const hexToUint8Array = (hex: string): Uint8Array => {
  if (hex.length % 2 !== 0) {
    throw new Error('Hex string must have an even length')
  }
  const byteArray = new Uint8Array(hex.length / 2)
  for (let i = 0; i < hex.length; i += 2) {
    byteArray[i / 2] = parseInt(hex.slice(i, i + 2), 16)
  }
  return byteArray
}

export function ua2string(_ua: Uint8Array | ArrayBuffer | Int8Array): string {
  let str = ''
  const ab = new Uint8Array(_ua)
  const abLen = ab.length
  const CHUNK_SIZE = Math.pow(2, 8)
  let offset, len, subab
  for (offset = 0; offset < abLen; offset += CHUNK_SIZE) {
    len = Math.min(CHUNK_SIZE, abLen - offset)
    subab = ab.subarray(offset, offset + len)
    str += String.fromCharCode.apply(null, subab as any)
  }
  return str
}

export const int8ArrayToBase64 = (int8Array: Int8Array): string => {
  return btoa(ua2string(int8Array))
}
